<div class="grid ">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoInserir">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="permissaoInserir">
			<form #f="ngForm" name="form" novalidate>
				<div class="formgroup">

					<div class="p-fluid p-formgrid grid">
						<div class="col-12 md:col-12">
							<button type="button" pButton icon="pi pi-plus" label="Importar" class="p-button-outlined sm:w-9rem"
							(click)="abrirDialogConta()">
							</button>
						</div>
						<div class="col-12 md:col-12">
							<p-divider></p-divider>
						</div>
						<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
							<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
						</div>
						<div class="field col-12 md:col-6">
							<label htmlFor="descricao">Descrição da Conta</label>
							<input type="text" pInputText placeholder="Descrição" name="descricao" ngModel #descricao="ngModel"
								required [readOnly]="true"/>
						</div>
						
						<div class="field col-12 md:col-6">
							<label htmlFor="especificacao">Especificação</label>
							<input type="text" pInputText placeholder="Especificação" name="especificacao" ngModel
								#especificacao="ngModel" required [readOnly]="true"/>
						</div>
						<div class="field col-12 md:col-6">
							<label htmlFor="dre">DRE</label>
							<input type="text" pInputText placeholder="DRE" name="dre" ngModel
								#dre="ngModel" required [readOnly]="true"/>
						</div>
						<div class="field col-12 md:col-6">
							<label htmlFor="planoContaGrupo">Grupo</label>
							<p-dropdown [options]="planosContaGrupos" optionLabel="descricao" [filter]="true"
								placeholder="Grupo" name="planoContaGrupo" ngModel #planoContaGrupo="ngModel"
								[readonly]="true">
							</p-dropdown>
						</div>
					</div>
					<div class="p-fluid p-formgrid grid justify-content-between">
						<div class="col-12 md:col-4">
							<button *ngIf="!progressoRequisicao else exibirBotaoFalso"
								type="button" pButton icon="pi pi-check" label="Salvar" (click)="salvar()"
								class="p-button-outlined p-button-success md:w-9rem" [disabled]="!f.valid">
							</button>
							<ng-template #exibirBotaoFalso>
								<button type="button" pButton icon="pi pi-spin pi-spinner" label="Salvar"
								class="p-button-outlined p-button-success md:w-9rem" disabled>
								</button>
							</ng-template>
						</div>
						<div class="col-12 md:col-4 flex justify-content-end">
							<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-outlined md:w-9rem" routerLink="/apps/plano-conta-empresa"></button>
						</div>
					</div>
				</div>
			</form>
			<p-dialog header="Importar Conta" [(visible)]="mostrarDialogConta" [modal]="true" [style]="{width: '50vw'}"
				[draggable]="false" [resizable]="false" [closable]="true" (onHide)="fecharDialogConta()">
				<div class="card">
					<p-table #dt1 [value]="listaContaMatriz" dataKey="id" [rows]="10" [rowHover]="true"
						styleClass="p-datatable-gridlines" [paginator]="false" responsiveLayout="scroll"
						styleClass=" p-datatable-sm">
						<ng-template pTemplate="header">
							<tr>
								<th>
									<div>
										Descrição
									</div>
								</th>
								<th>
									<div>
										DRE
									</div>
								</th>
			
								<th>
									<div>
										Importar
									</div>
								</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-item let-i="rowIndex">
							<tr>
								<td>
									<label class="form-control">{{ item.descricao }}</label>
								</td>
								<td>
									<label class="form-control">{{ item.dre }}</label>
								</td>
			
								<td>
									<button pButton pRipple pTooltip="Importar Conta" type="button" icon="pi pi-check"
										class="p-button-success" (click)="importarConta(item)">
									</button>
								</td>
							</tr>
						</ng-template>
					</p-table>
				</div>
			</p-dialog>
		</div>
	</div>
</div>